import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { GenericNgxDataTableComponent } from './generic-ngx-data-table/generic-ngx-data-table.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [ContextMenuComponent,GenericNgxDataTableComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgxDatatableModule
  ],
  exports: [ContextMenuComponent, GenericNgxDataTableComponent]
})
export class SharedModule { }
